import _ from 'lodash'
import constants from '../constants'
import { errorKey } from '../utils'

let initialOrderState = {
  buyer: {
    name: '',
    phone: '',
    comment: '',
    sended: false
  },
  groups: {
    construction: {
      title: 'Тип конструкции',
      selected: '',
      items: []
    },
    size: {
      title: 'Размер',
      selected: '',
      items: [],
      inputValues: []
    },
    open: {
      title: 'Сторона открывания',
      selected: '',
      item: null
    },
    parts: [],
    orderPositionIndex: 3
  }
};

let orderState = {
  actionsChain: [],
  hint: null,
  buyer: {
    name: '',
    phone: '',
    comment: '',
  },
  errors: {},
  groups: JSON.parse(JSON.stringify(initialOrderState.groups)),
  needForcePopupFor: null
};

const orderReducer = function(state = orderState, action) {
  let construction = null;

  switch(action.type) {
    case constants.ACTIONS.GROUP_SELECTED:
      construction = action.payload.construction;
      state.groups[action.payload.group]['selected'] = action.payload.slug;
      state.groups[action.payload.group]['items'] = action.payload.slug == 'SIZE' ? [construction.sizes[0]] : [];

      return Object.assign({}, state);

    case constants.ACTIONS.CUSTOM_SIZE_SELECTED:
      let sizes = action.payload.sizes;

      state.groups['size']['items'] = action.payload.sizes;
      state.groups['size']['inputValues'] = action.payload.inputValues;
      return Object.assign({}, state);

    case constants.ACTIONS.UPDATE_ORDER_PARAMS:
      return Object.assign({}, state, action.payload);

    case constants.ACTIONS.SHOW_HINT:
      return Object.assign({}, state, {hint: action.payload});

    case constants.ACTIONS.HIDE_HINT:
      return Object.assign({}, state, {hint: null});

    case constants.ACTIONS.ADD_TO_ACTIONS_CHAIN:
      let actions = state.actionsChain;

      return Object.assign({}, state, {actionsChain: _.uniq([...actions, ...action.payload])});

    case constants.ACTIONS.REMOVE_FROM_ACTIONS_CHAIN:
      let newChain = [...state.actionsChain];
      _.remove(newChain, item => item == errorKey(action.payload));
      return Object.assign({}, state, {actionsChain: _.uniq(newChain)});

    case constants.ACTIONS.SET_FORCE_POPUP_FOR:
      return Object.assign({}, state, action.payload);

    case constants.ACTIONS.CONSTRUCTION_TYPE_SELECTED:
      let
        constructions = state.groups.construction;
      constructions.items = [action.payload.selected_type];
      return Object.assign({}, state);

    case constants.ACTIONS.CONSTRUCTION_PART_SELECTED:
      let
        parts = state.groups.parts,
        item = action.payload.item;
      if (_.find(parts, {id: item.id, type: item.type})) {
        parts = _.reject(parts, {id: item.id, type: item.type});
      } else {
        state.groups.orderPositionIndex += 1;
        item.orderIndex = state.groups.orderPositionIndex;

        parts.push(item);
      }
      state.groups.parts = parts;
      return Object.assign({}, state);

    case constants.ACTIONS.CONSTRUCTION_ITEM_GROUPED_SELECTED:
      let
        part = state.groups[action.payload.group],
        item2 = action.payload.item;
      state.needForcePopupFor = null;

      if (part && part.id == item2.id && part.type == item2.type) {
        part = null;
      } else {
        part = (item2);
        state.groups.orderPositionIndex += 1;
        part.orderIndex = state.groups.orderPositionIndex;
      }
      if (action.payload.group == 'InsidePanel') {
        if (part == null) {
          state.groups['InsideColor'] = null;
        } else {
          state.needForcePopupFor = 'InsideColor';
        }
      }
      state.groups[action.payload.group] = part;
      return Object.assign({}, state);

    case constants.ACTIONS.SIZE_SELECTED:
      state.groups['size']['items'] = [action.payload.size];
      return Object.assign({}, state);

    case constants.ACTIONS.OPEN_TYPE_SELECTED:
      state.groups['open']['item'] = action.payload.item;
      return Object.assign({}, state);

    case constants.ACTIONS.SET_DEFAULT_ORDER_STATE:
      construction = action.payload.construction;
      if (construction) {
        state.groups = JSON.parse(JSON.stringify(initialOrderState.groups));
        state.groups.construction.items = [construction];
      }
      return Object.assign({}, state);

    case constants.ACTIONS.STEP_INVALID:
      state.errors[`step-${action.payload.step}`] = action.payload.errors;
      return Object.assign({}, state);

    case constants.ACTIONS.STEP_VALID:
      state.errors[`step-${action.payload.step}`] = [];
      return Object.assign({}, state);
  }

  return state;
};
export default orderReducer;


// WEBPACK FOOTER //
// ./app/javascript/app/reducers/order.js